<template>
<div class="layout home_style">
    <Layout>
        <Sider hide-trigger collapsible v-model="isCollapsed" :style="leftHeight">
            <standardSysLeftMenu @changeLeft="changeLeft" @showContent="showContent"></standardSysLeftMenu>
        </Sider>
        <Layout>
            <Header>
                <standardSysHeadShow @dialer="dialer" @monitorData="monitorData" @seatMonitorData="seatMonitorData" @openPeopleSet="openPeopleSet" ref="contentHead"></standardSysHeadShow>
            </Header>
            <Content>
                <standardSysContent ref="content" @noticeShow="noticeShow" @callTelephone="callTelephone" @getSeatAndSkill="getSeatAndSkill" :isCollapsed="isCollapsed"></standardSysContent>
            </Content>
        </Layout>
    </Layout>
</div>
</template>

<script>
import standardSysHeadShow from '@/components/login/StandardSysHeadShow.vue'
import standardSysLeftMenu from '@/components/login/StandardSysLeftMenu.vue'
import standardSysContent from '@/components/login/StandardSysContent.vue'
export default {
    name: 'StandardSysCombination',
    components: {
        standardSysHeadShow,
        standardSysLeftMenu,
        standardSysContent
    },
    data() {
        return {
            leftHeight: {
                height: '',
                width: '180px',
                minWidth: '180px',
                maxWidth: '180px'
            },
            isCollapsed: false,
            contentHead: '',
            token: localStorage.getItem("token"),
            configInfo: JSON.parse(localStorage.getItem("configInfo")),
        }
    },
    methods: {
        noticeShow:function(item){
            this.$refs.contentHead.clicknoticeTable(item);
        },
        //切换左边栏显示与隐藏
        changeLeft: function () {
            if (this.isCollapsed) {
                this.isCollapsed = false;
                this.leftHeight.minWidth = "180px";
                this.leftHeight.minWidth = "180px";
                localStorage.setItem("isCollapsed", "false");
            } else {
                this.isCollapsed = true;
                this.leftHeight.minWidth = "45px";
                this.leftHeight.maxWidth = "45px";
                localStorage.setItem("isCollapsed", "true");
            }
        },
        //切换右边页面显示内容
        showContent: function (obj) {
            this.$refs.content.showStandardPage(obj);
        },
        dialer: function (obj, reserve) {
           this.$store.commit('addReserve',reserve)
            this.$refs.content.showStandardPage(obj, reserve);
        },
        //打开个人设置 知识查看 网络延迟
        openPeopleSet: function (sign, id) {
            if (sign == 'people') {
                this.$refs.content.showStandardPage("4_4,个人设置");
            }
            if (sign == 'know') {
                let name = "知识查看";
                if(id && id.indexOf("-") != -1){
                  let list = id.split("-");
                  name = list[1];
                  id = list[0];
                }
                this.$refs.content.showStandardPage("6_3-"+id+","+name+"", id);
            }
            if (sign == 'signal') {
                this.$refs.content.showStandardPage("signal,网络延迟");
            }
            if(sign == 'online'){
                this.$refs.content.showStandardPage("online,在线客服");
            }
            if(sign.indexOf('b_w_1-') > -1){
                this.$refs.content.showStandardPage(sign,[]);
                let signNew = sign.split(',')[0];
                let param = {
                  pageUuId:signNew,
                };
                let newGroupList = [];
                newGroupList.push(param)
                this.$store.commit('addWorkOrderReserve',newGroupList);
            }
        },

        monitorData: function (obj) {
            this.$refs.content.monitorListData(obj);
        },
        seatMonitorData: function (obj) {
            this.$refs.content.seatMonitorData(obj);
        },
        callTelephone: function (flag, phone, sign, cusData) {
            this.$refs.contentHead.closeDialerPage(true, phone, sign, cusData);
        },
        getSeatAndSkill: function (arg, key, value) {
            this.$refs.contentHead.sendMessage(arg, key, value);
        }
    },
    created() {
        let token = localStorage.getItem("token");
        let companyId = localStorage.getItem("companyId");
        this.$http.defaults.headers.Authorization = "Bearer " + token;
        this.$http.defaults.headers.companyCode = companyId;
        this.leftHeight.height = document.documentElement.clientHeight - 1 + 'px';
        let loginSign = localStorage.getItem("loginSign");
        if (loginSign != '0') {
            this.$router.push({
                path: '/login'
            });
            let loginUrl = localStorage.getItem("loginUrl");
            window.location.href = loginUrl;
        } else {
            localStorage.setItem('loginSign', "1");
        }
    }
}
</script>

<style lang="less" >

</style>



// WEBPACK FOOTER //
// src/components/login/StandardSysCombination.vue